var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgQuoteClose = function SvgQuoteClose(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "aca07b35-cb9e-40ad-a4a9-bfbf2cabcc49",
    "data-name": "Layer 1",
    width: 53.156,
    height: 39.516,
    viewBox: "0 0 53.156 39.516",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M.617,19.2V.711H20.656V15.547q0,10.336-5.062,16.594Q10.6,38.4.969,40.227V32.844q7.1-2.25,9.562-7.735A11.872,11.872,0,0,0,11.656,19.2ZM48.922,31.93q-4.921,6.4-14.766,8.3V32.844q7.242-2.18,9.633-8.016a14.39,14.39,0,0,0,.984-5.625H33.805V.711H53.773V15.547Q53.773,25.6,48.922,31.93Z",
    transform: "translate(-0.617 -0.711)",
    fill: "currentColor"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgQuoteClose, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/quote-close.03021c74.svg";
export { ForwardRef as ReactComponent };